module.exports = __webpack_public_path__ + "static/media/low-tornillos.ff8fdc0b.png";